import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
const navLinks = [{
  name: 'Gallery',
  href: '/#gallery'
}, {
  name: 'Celebrate',
  href: '/#celebrate'
}, {
  name: 'Honor',
  href: '/#honor'
}, {
  name: 'Support',
  href: '/#support'
}, {
  name: 'Event',
  href: '/#event'
}, {
  name: 'Partner',
  href: '/#partner'
}, {
  name: 'About',
  href: '/about'
}];
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu when route changes
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);
  return <nav className={`sticky top-0 z-50 w-full bg-white/95 backdrop-blur-sm border-b border-[#ecdfd2] transition-all duration-300 ease-out ${isScrolled ? 'shadow-sm' : ''}`} data-id="element-104" data-mp="9ny5ge1xdbhp">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105" data-mp="jnyodyvvtpld">
        <div className={`flex justify-between items-center transition-all duration-300 ease-out ${isScrolled ? 'h-16' : 'h-24'}`} data-id="element-106" data-mp="om9ymaq3a244">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-107" data-mp="3n1jadcxozqy7">
            <Link to="/" className="flex items-center gap-3" data-id="element-108" data-mp="3s38juo59nwk6">
              <img src="https://cdn.magicpatterns.com/uploads/4tAPPhhSxFFzHh1MdQYkPw/Good_Father_Project.png" alt="Good Father Project Logo" className={`w-auto transition-all duration-300 ease-out ${isScrolled ? 'h-8' : 'h-12'}`} data-id="element-109" data-mp="vmdgnr5xfzm" />
              <span className={`font-bold text-[#3b2316] hidden sm:block transition-all duration-300 ease-out ${isScrolled ? 'text-lg' : 'text-2xl'}`} data-id="element-110" data-mp="39bpmawu0hapj">
                Good Father Project
              </span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-111" data-mp="3b1mem8m44t84">
            {navLinks.map(link => {
            // Check if it's an internal route or hash link
            const isInternal = link.href.startsWith('/') && !link.href.includes('#');
            if (isInternal) {
              return <Link key={link.name} to={link.href} className={`text-[#5a3a28] hover:text-[#c06a2b] font-medium transition-all duration-300 ${isScrolled ? 'text-sm' : 'text-base'}`} data-id="element-112" data-mp="2devol80y9ucz">
                    {link.name}
                  </Link>;
            }
            return <a key={link.name} href={link.href} className={`text-[#5a3a28] hover:text-[#c06a2b] font-medium transition-all duration-300 ${isScrolled ? 'text-sm' : 'text-base'}`} data-id="element-113" data-mp="2k80fva67ioz">
                  {link.name}
                </a>;
          })}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-114" data-mp="5560dewan8wc">
            <button onClick={() => setIsOpen(!isOpen)} className="text-[#5a3a28] hover:text-[#3b2316] p-2" aria-label="Toggle menu" data-id="element-115" data-mp="57s7xej6poek">
              {isOpen ? <X size={24} data-id="element-116" data-mp="xwh9feo5jvqu" /> : <Menu size={24} data-id="element-117" data-mp="k2yf44u0nt9h" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && <div className="md:hidden bg-white border-b border-[#ecdfd2] shadow-lg absolute w-full" data-id="element-118" data-mp="o38v8abiw022">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-119" data-mp="1bt346gsq14h1">
            {navLinks.map(link => {
          const isInternal = link.href.startsWith('/') && !link.href.includes('#');
          if (isInternal) {
            return <Link key={link.name} to={link.href} className="block px-3 py-3 text-base font-medium text-[#5a3a28] hover:text-[#c06a2b] hover:bg-[#ecdfd2]/20 rounded-md" data-id="element-120" data-mp="3k2ua3qtykw4u">
                    {link.name}
                  </Link>;
          }
          return <a key={link.name} href={link.href} className="block px-3 py-3 text-base font-medium text-[#5a3a28] hover:text-[#c06a2b] hover:bg-[#ecdfd2]/20 rounded-md" onClick={() => setIsOpen(false)} data-id="element-121" data-mp="bm94mk0jcl6h">
                  {link.name}
                </a>;
        })}
          </div>
        </div>}
    </nav>;
}